import { createTheme } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles'
import Tooltip from '@material-ui/core/Tooltip'
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined'
import { IconButton, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const theme = createTheme({
  palette: {
    action: {
      disabled: '#9CA3AF',
    },
  },
})

function OnlineButton() {
  const { t } = useTranslation()

  return (
    <ThemeProvider theme={theme}>
      <div style={{ marginRight: '5px' }}>
        <a
          href='https://app.chedar.fr'
          target='_blank'
          rel='noreferrer'
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <IconButton
            aria-label='link to offline'
            aria-controls='button'
            color='inherit'
            onClick={() => {}}
            // disabled={true}
          >
            <CloudUploadOutlinedIcon style={{ marginRight: '5px' }} />
            <Typography variant='subtitle2'>{t('OfflineButton:online')}</Typography>
          </IconButton>
        </a>
      </div>
    </ThemeProvider>
  )
}

export default OnlineButton
